import { WishlistManagerSection } from '@/components/wishlist/WishlistManagerSection';

export default function WishlistPage() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Wishlist</h1>
        <p className="text-sm text-muted-foreground">
          Track customer vehicle wishlists and see what's in highest demand.
        </p>
      </div>
      <WishlistManagerSection />
    </div>
  );
}